import React from 'react';
import { useTranslation } from 'react-i18next';
import { CellProps } from 'react-table';
import { Button, ResponsiveDataTable } from '@tq/ui-components';

import { hiddenTableHeaderLabel } from 'components';
import { useNavigate } from 'hooks';
import { PastResponse } from 'types';
import { ResponseMobileCard } from '../ResponseMobileCard';
import { useFormatLocaleDate } from 'config/DateFormats/useFormatLocaleDate';

type ArchivedResponsesDataTableProps = {
  consultationId: number | undefined;
  pastResponses: PastResponse[];
};

export const ArchivedResponsesDataTable: React.FC<ArchivedResponsesDataTableProps> = ({
  consultationId,
  pastResponses,
}) => {
  const { t } = useTranslation('consultation_response');
  const { navigateToArchivedResponse } = useNavigate();
  const formatLocaleDate = useFormatLocaleDate();

  return (
    <ResponsiveDataTable
      data={pastResponses}
      filters={[]}
      initialState={{
        sortBy: [
          {
            id: 'responseDate',
            desc: true,
          },
        ],
      }}
      Card={(row) => (
        <ResponseMobileCard
          id={row.id}
          type={row.type}
          response={row.response}
          responseDate={row.responseDate}
        />
      )}
      columns={[
        {
          accessor: 'type',
          disableSortBy: true,
          Cell: (cellProps: { value: string }) => cellProps.value,
          Header: () => t('response_type', 'Response type'),
          width: '170px',
        },
        {
          accessor: 'responseDate',
          Cell: (cellProps: { value: string }) => formatLocaleDate(cellProps.value),
          Header: () => t('response_date', 'Response date'),
          width: '200px',
        },
        {
          accessor: 'response',
          disableSortBy: true,
          Cell: (cellProps: { value: string }) => cellProps.value,
          Header: () => t('summary', 'Summary'),
          width: 'auto',
        },
        {
          accessor: 'id',
          Cell: ({ row: { original } }: CellProps<PastResponse>) => (
            <Button
              variant='secondary'
              size='xs'
              onClick={() =>
                consultationId && navigateToArchivedResponse(consultationId, original.id)
              }
            >
              {t('view_response', 'View response')}
            </Button>
          ),
          disableSortBy: true,
          Header: () => hiddenTableHeaderLabel(t('view_label', 'view')),
          width: 20,
        },
      ]}
    />
  );
};
